import * as VeeValidate from "vee-validate";
export default VeeValidate;
